import { render, staticRenderFns } from "./EditArtworkForm.vue?vue&type=template&id=5d9492ec"
import script from "./EditArtworkForm.vue?vue&type=script&lang=ts"
export * from "./EditArtworkForm.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./EditArtworkForm.vue?vue&type=style&index=0&id=5d9492ec&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports